import { render, staticRenderFns } from "./DialogPool.vue?vue&type=template&id=9d256d5a&scoped=true"
import script from "./DialogPool.vue?vue&type=script&lang=js"
export * from "./DialogPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.7.4_webpack@5.102.1__ejs@3.1.1_8e3b2d983739573c8a37493d5fe535f8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d256d5a",
  null
  
)

export default component.exports